import { useState, useRef } from "react";
import api from "../api";
import { Paperclip, Download, Trash2, Upload, FileText, Eye } from "lucide-react";

export default function AnexosBox({ tipo, id, anexos = [] }) {
  const [lista, setLista] = useState(anexos);
  const [enviando, setEnviando] = useState(false);
  const inputRef = useRef();

  const fmtTam = (b) => b >= 1048576 ? (b / 1048576).toFixed(1) + " MB" : Math.max(1, Math.round(b / 1024)) + " KB";

  const escolher = () => {
    if (!id) { alert("Salve o registro primeiro para poder anexar arquivos."); return; }
    if (inputRef.current) inputRef.current.click();
  };

  const enviar = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { alert("Arquivo maior que 10MB."); e.target.value = ""; return; }
    setEnviando(true);
    try {
      const fd = new FormData();
      fd.append("arquivo", file);
      const r = await api.post(`/anexos/doc/${tipo}/${id}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setLista(r.data.anexos || []);
    } catch (err) {
      alert("Erro ao enviar: " + ((err.response && err.response.data && err.response.data.erro) || err.message));
    }
    setEnviando(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const remover = async (idx) => {
    if (!window.confirm("Remover este anexo?")) return;
    try {
      const r = await api.delete(`/anexos/doc/${tipo}/${id}/${idx}`);
      setLista(r.data.anexos || []);
    } catch (err) {
      alert("Erro ao remover: " + ((err.response && err.response.data && err.response.data.erro) || err.message));
    }
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: .4, display: "flex", alignItems: "center", gap: 5 }}>
          <Paperclip size={12} />Anexos{lista.length ? ` (${lista.length})` : ""}
        </span>
        <button type="button" onClick={escolher} disabled={enviando}
          style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 12px", fontSize: 12, fontWeight: 600, color: "#fff", background: "#EE6A1A", border: "none", borderRadius: 6, cursor: "pointer", opacity: enviando ? .6 : 1 }}>
          <Upload size={13} />{enviando ? "Enviando..." : "Anexar arquivo"}
        </button>
        <input ref={inputRef} type="file" style={{ display: "none" }} onChange={enviar} />
      </div>
      {!lista.length && (
        <div style={{ fontSize: 12, color: "var(--text-muted)", padding: "8px 0" }}>
          Nenhum anexo. Ate 10MB por arquivo (PDF, imagem, planilha, etc).
        </div>
      )}
      {lista.map((a, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 10px", border: "1px solid var(--border-color)", borderRadius: 6, marginBottom: 6, background: "var(--card-bg)" }}>
          <FileText size={16} color="#EE6A1A" style={{ flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, color: "var(--text-primary)", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.nome}</div>
            <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{fmtTam(a.tamanho || 0)}{a.nomeUsuario ? ` · ${a.nomeUsuario}` : ""}{a.createdAt ? ` · ${new Date(a.createdAt).toLocaleDateString("pt-BR")}` : ""}{a.createdAt ? ` · ${new Date(a.createdAt).toLocaleDateString("pt-BR")}` : ""}</div>
          </div>
          <a href={a.url} target="_blank" rel="noreferrer" title="Abrir em nova aba" style={{ color: "#1D9E75", display: "flex" }}><Eye size={16} /></a>
          <a href={a.url} download={a.nome} title="Baixar" style={{ color: "#579bfc", display: "flex" }}><Download size={16} /></a>
          <button type="button" onClick={() => remover(i)} title="Remover" style={{ background: "none", border: "none", cursor: "pointer", color: "#E24B4A", display: "flex", padding: 0 }}><Trash2 size={16} /></button>
        </div>
      ))}
    </div>
  );
}
